'use strict';

var Backdrop = require('./backdrop');


module.exports = {
    Backdrop: Backdrop
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/gradience/environ/index.js
 ** module id = 12
 ** module chunks = 0
 **/